import { render, staticRenderFns } from "./suspendu.vue?vue&type=template&id=108bed69"
import script from "./suspendu.vue?vue&type=script&lang=js"
export * from "./suspendu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports